<div class="m-2 d-flex flex-column">
    <p-editor required [(ngModel)]="comment.body" name="logBody" id="logBody" styleClass="w-100 my-4 mx-2">
        <p-header>
            <span class="ql-formats">
                <button class="ql-bold" aria-label="Bold"></button>
                <button class="ql-italic" aria-label="Italic"></button>
                <button class="ql-underline" aria-label="Underline"></button>
                <button class="ql-strike" aria-label="Strike"></button>
            </span>
            <span class="ql-formats">
                <button class="ql-list" value="ordered"></button>
                <button class="ql-list" value="bullet"></button>
            </span>
        </p-header>
    </p-editor>
    <div class="d-flex flex-column justify-content-end">
        <p-button pRipple styleClass="p-button-raised my-2 me-2 ms-auto" (click)="save()">
            <ng-template pTemplate="content">
                <fa-icon [icon]='["far","save"]' size="lg" class="ms-1"></fa-icon>
            </ng-template>
        </p-button>
    </div>

</div>